import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ServiceTypeId } from '@/services/api/petseo.client.wrapper';

interface ServiceVendorFilters {
  serviceTypeId?: ServiceTypeId | null;
  name?: string | null;
  isActive?: boolean | null;
}

interface ServiceVendorFiltersState {
  filters: ServiceVendorFilters;
}

interface ServiceVendorFiltersActions {
  setFilters: (filters: ServiceVendorFilters) => void;
  updateFilter: <K extends keyof ServiceVendorFilters>(key: K, value: ServiceVendorFilters[K]) => void;
  clearFilters: () => void;
}

const initialFilters: ServiceVendorFilters = {
  serviceTypeId: null,
  name: null,
  isActive: null,
};

export const useServiceVendorFiltersStore = create<ServiceVendorFiltersState & ServiceVendorFiltersActions>()(
  persist(
    (set) => ({
      filters: initialFilters,

      setFilters: (filters) => set({ filters }),

      updateFilter: (key, value) =>
        set((state) => ({
          filters: { ...state.filters, [key]: value },
        })),

      clearFilters: () => set({ filters: initialFilters }),
    }),
    {
      name: 'service-vendor-filters',
      partialize: (state) => ({ filters: state.filters }),
    }
  )
);
